import { Inheritance } from 'src/domain';
import { useGenderSplitInheritanceQuery } from './useGenderSplitInheritanceQuery';

export const useGenderSplitQuery = (inheritance?: Inheritance) => {
    return useGenderSplitInheritanceQuery(inheritance);
};
